import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-generic-content-node',
  templateUrl: './generic-content-node.component.html',
  styleUrls: ['./generic-content-node.component.scss']
})
export class GenericContentNodeComponent {
  @Input() node: any;
}
